import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography,
} from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../../Translations';
import { previewStore } from '../../../../../LearningCollectionPreviewStore';

function CancelModal() {
  const handleDiscard = () => {
    previewStore.discardChanges();
  };

  return (
    <Modal open={true} onClose={() => previewStore.wait()}>
      <ModalHeader className="w-full justify-between items-center">
        <Typography variant="subtitleLarge" fontWeight="semibold">
          <T kind="Discard this collection" />
        </Typography>
      </ModalHeader>
      <ModalBody>
        <Typography variant="bodyMedium">
          <T kind="If you leave now the collection will not be saved and cannot be restored later. Are you sure you want to continue?" />
        </Typography>
      </ModalBody>
      <ModalFooter className="flex-row justify-end">
        <Button variant="text" color="secondary" onClick={() => previewStore.wait()}>
          <T kind="Cancel" />
        </Button>
        <Button color="error" onClick={handleDiscard}>
          <T kind="Discard Changes" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default observer(CancelModal);
